import { h } from 'preact';

const Button = ({ text, classes = [], handleClick }) => (
  <button
    class={classes.concat('button').join(' ')}
    onClick={handleClick.bind(null, text)}
  >
    {text}
  </button>
);

export default Button;
